import { makeActionCreator } from '../../../../utilities'
import { PnProcedureConstants } from './pnProcedure.constants'

export const setPnProcedureState = makeActionCreator(PnProcedureConstants.SET_STATE, 'pnProcedureState')
export const resetState = makeActionCreator(PnProcedureConstants.RESET_STATE)
export const savePnProcedure = makeActionCreator(PnProcedureConstants.SAVE_PN_PROCEDURE)
export const setAddToTimeLine = makeActionCreator(PnProcedureConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setPnProcList = makeActionCreator(PnProcedureConstants.SET_PN_PROCEDURE_LIST, 'procedurePNNVs')
export const setDateTime = makeActionCreator(PnProcedureConstants.SET_DATE_TIME, 'time', 'date')
export const setPnProcedure = makeActionCreator(PnProcedureConstants.SET_PN_PROCEDURE, 'pnProcedure')
export const setPTA = makeActionCreator(PnProcedureConstants.SET_PTA, 'pta')
